export const PAGE_ID = "page";
export const PAGE_MAX_WIDTH = 1440;
